"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getWebshellclientLocale = _interopRequireDefault(require("../utils/get-webshellclient-locale"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * @description Basic feature flag for global store geos that use fulfillment offerings and partner cart reviews v2. Keeping it simple for now.
 * @returns {boolean} - true if the current country is a global store geos enabled country, false otherwise
 */
var determineGlobalStoreFoffsEnabled = function determineGlobalStoreFoffsEnabled() {
  var _getWebShellClientLoc = (0, _getWebshellclientLocale["default"])(),
    country = _getWebShellClientLoc.country;
  if (country === 'mx') {
    return true;
  }
  return false;
};
var _default = exports["default"] = determineGlobalStoreFoffsEnabled;